module.exports = __webpack_public_path__ + "static/media/snaplark_video_null.40cea856.mp4";